import { render } from "./AffectPricingNotificationModal.vue?vue&type=template&id=07762e03"
import script from "./AffectPricingNotificationModal.vue?vue&type=script&lang=js"
export * from "./AffectPricingNotificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/modals/Notifications/AffectPricingNotificationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07762e03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07762e03', __exports__)) {
    api.reload('07762e03', __exports__)
  }
  
  module.hot.accept("./AffectPricingNotificationModal.vue?vue&type=template&id=07762e03", () => {
    api.rerender('07762e03', render)
  })

}


export default __exports__